export default __webpack_public_path__ + "static/media/pug.48c206b7.webp";